import React from "react";
import Typography from "../../Typography/Typography";

const ProjectsList = ({
    projects,
    selectedProject,
    selectedNodesIndicators,
    onProjectSelect,
}) => {
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom py-3">
                <div className="d-flex align-items-center">
                    <i className="bi bi-folder2 text-primary me-2"></i>
                    <Typography variant="h5" className="mb-0">
                        Projects
                    </Typography>
                </div>
            </div>
            <div
                className="list-group list-group-flush overflow-auto"
                style={{ maxHeight: "400px" }}
            >
                {projects && projects.length > 0 ? (
                    projects.map((project) => (
                        <div
                            key={project.id}
                            className={`list-group-item d-flex justify-content-between align-items-center py-3 px-3 ${
                                selectedProject?.id === project.id
                                    ? "bg-light"
                                    : ""
                            }`}
                            onClick={() => onProjectSelect(project)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="d-flex align-items-center">
                                <div
                                    className={`me-2 rounded-circle d-flex align-items-center justify-content-center ${
                                        selectedProject?.id === project.id
                                            ? "bg-primary text-white"
                                            : "bg-light"
                                    }`}
                                    style={{
                                        width: "28px",
                                        height: "28px",
                                    }}
                                >
                                    <i
                                        className={`bi ${selectedProject?.id === project.id ? "bi-check" : "bi-folder"} small`}
                                    ></i>
                                </div>
                                <div>
                                    <Typography
                                        variant="body1"
                                        className="mb-0"
                                    >
                                        {project.name || project.title}
                                    </Typography>
                                    {selectedNodesIndicators[project.id] >
                                        0 && (
                                        <small className="text-primary">
                                            {
                                                selectedNodesIndicators[
                                                    project.id
                                                ]
                                            }{" "}
                                            node(s) selected
                                        </small>
                                    )}
                                </div>
                            </div>
                            {selectedProject?.id === project.id && (
                                <i className="bi bi-chevron-right text-primary"></i>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="list-group-item text-center py-4">
                        <i className="bi bi-folder-x text-muted fs-3 d-block mb-2"></i>
                        <p className="text-muted mb-0">No projects found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectsList;
